import api from "../config/api";

export const getAllWishlist = async ()=>{
  const res = await api.get(`/wishlist/`)
  return res.data;
}
export const getWishlistById = async (id)=>{
  const res = await api.get(`/wishlist/?id=${id}`)
  return res.data;
}

export const getWishlistProductsByCustomerId = async (customerId)=>{
  const res = await api.get(`/wishlist/?customerId=${customerId}`)
  return res.data;
}

export const createWishlist = async (data) => {
  const res = await api.post(`/wishlist/`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data.data;
}

export const updateWishlist= async(id, wishlistData)=>{
    const res = await api.post(`/wishlist/?id=${id}`,wishlistData);
    return res.data;
}

export const deleteWishlistById = async (id) => {
  const res = await api.delete(`/wishlist/?id=${id}`);
  return res.data.data;
} 

export const deleteWishlistByCustomerId = async (customerId) => {
  const res = await api.delete(`/wishlist/?customerId=${customerId}`);
  return res.data.data;
} 